// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1963) return "static/chunks/1963-c6be486ea432e97d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "bdcbcf59d6015276" + ".js";
};